// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2639":"5ca50945","3052":"3e1f9cd7","3872":"aafa104e","4485":"c2e76381","5113":"ba06af1f","8155":"ba06af1f","8236":"ba06af1f"}[chunkId] + ".chunk.css";
};